import React from 'react'
import { Router, Switch, Route } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { StateProvider } from '@State'
import { Toaster } from '@CommonComponents/toast'
import { AchievementGroups } from './AchievementGroups'
import { EditAchievement } from './EditAchievement'

export const history = createBrowserHistory()

export const App = ({
  badgeTemplates,
  certTemplates,
  badges,
  certificates,
  acts,
  coursenum,
}) => {
  const initialState = {
    acts: acts,
    certificates: certificates,
    badges: badges,
    badgeTemplates: badgeTemplates,
    certificateTemplates: certTemplates,
    coursenum: coursenum,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'updateCerts':
        return {
          ...state,
          certificates: action.payload,
        }
      case 'updateBadges':
        return {
          ...state,
          badges: action.payload,
        }
    }
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <Toaster />
      <Router history={history}>
        <Switch>
          <Route
            exact
            path="/instructor/achievements/:coursenum/:itemId/:acmtType/edit/"
            component={EditAchievement}
          />
          <Route path="*" component={AchievementGroups} />
        </Switch>
      </Router>
    </StateProvider>
  )
}
